// extracted by mini-css-extract-plugin
export default {"timeline":"Layout_timeline__fBfdx","mainMenu":"Layout_mainMenu__Biys6","menuItem":"Layout_menuItem__G4rUC","info":"Layout_info__Ig0un"};